import { createFileRoute } from "@tanstack/react-router"
import { meta } from "@/content"
import { RequestVerifyEmail } from "@/app"

export const Route = createFileRoute("/$locale/auth/verify/request")({
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Verify your Email" }) }),
})

function RouteComponent() {
  return <RequestVerifyEmail />
}
